"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getShareVouchers = exports.appendToDistributionOnVoucher = exports.distribute = void 0;
const __1 = __importDefault(require(".."));
const helpers_1 = require("./helpers");
const distribute = (caseVouchers, order, preInterestModifier, modifier) => {
    const sortedVouchers = caseVouchers
        .sort((voucherA, voucherB) => __1.default.utils.sortBy((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime(), (a, b) => a.amount - b.amount)(voucherA, voucherB))
        .map((cv) => {
        let voucherWithDistribution = cv;
        voucherWithDistribution.distribution = [];
        voucherWithDistribution.distributionAmount = 0;
        return voucherWithDistribution;
    });
    let vouchersToProcess = sortedVouchers;
    if (preInterestModifier) {
        vouchersToProcess = preInterestModifier(sortedVouchers);
    }
    let state = [];
    for (let i = 0; i < vouchersToProcess.length; i++) {
        const caseVoucher = vouchersToProcess[i];
        const nextState = appendVoucherToState(state, caseVoucher, order);
        if (modifier) {
            state = modifier(nextState, state, nextState[i], vouchersToProcess[i + 1]);
        }
        else {
            state = nextState;
        }
    }
    return state;
};
exports.distribute = distribute;
const appendVoucherToState = (vouchers, voucher, order) => {
    vouchers = vouchers.sort((voucherA, voucherB) => order(voucherA, voucherB, voucher));
    for (let i = 0; i < vouchers.length; i++) {
        const from = voucher.distributionAmount - voucher.amount;
        if (from === 0)
            break;
        const toVoucher = vouchers[i];
        const to = toVoucher.distributionAmount - toVoucher.amount;
        if (to === 0 ||
            (to > 0 && from > 0) ||
            (to < 0 && from < 0)) {
            continue;
        }
        const distributionAmount = to > from ? (to < -from ? -to : from) : -to < from ? -to : from;
        voucher = (0, exports.appendToDistributionOnVoucher)(voucher, -distributionAmount, toVoucher.caseVoucherId, toVoucher.date);
        vouchers[i] = (0, exports.appendToDistributionOnVoucher)(vouchers[i], distributionAmount, voucher.caseVoucherId, voucher.date);
    }
    return vouchers.concat(voucher);
};
const appendToDistributionOnVoucher = (voucher, amount, caseVoucherId, date) => {
    voucher.distribution = (voucher.distribution || []).concat({
        caseVoucherId,
        amount,
        date,
    });
    voucher.distributionAmount = (voucher.distributionAmount || 0) + amount;
    return voucher;
};
exports.appendToDistributionOnVoucher = appendToDistributionOnVoucher;
const getShareVouchers = (baseVoucher, documents, expirationSettings, _case, billingModel, caseVouchers) => {
    if (!billingModel) {
        return [[], [], []];
    }
    if (!billingModel.model.share)
        throw new Error('Please only use this function for connectors with a share');
    let newBillingVouchers = [];
    let newResidueBillingVouchers = [];
    let newOverheadBillingVouchers = [];
    let savedUpBillingVouchers = [];
    const vouchersWithInterest = (0, helpers_1.getVoucherWithInterest)(billingModel, caseVouchers, documents, expirationSettings);
    if (!vouchersWithInterest) {
        throw new Error('Billing: Could not find vouchers');
    }
    const vouchersWithDistribution = (0, helpers_1.findAndSort)(vouchersWithInterest, billingModel.model.fromVoucherTypeIds);
    for (let i = 0; i < vouchersWithDistribution.length; i++) {
        const voucherWithDistribution = vouchersWithDistribution[i];
        if (!(0, helpers_1.caseBillingIsActive)(voucherWithDistribution.contraCaseVoucher.date, _case)) {
            continue;
        }
        const shares = (0, helpers_1.getCollectionCommissionMatches)(billingModel, _case, voucherWithDistribution);
        const shareBaseVoucher = (0, helpers_1.getBaseBillingVoucher)(baseVoucher, voucherWithDistribution, billingModel);
        let newCollectionCommissionBillingVouchers = [];
        let shareAmount = 0;
        for (let f = 0; f < shares.length; f++) {
            const share = shares[f];
            const amount = Math.round(voucherWithDistribution.amountFromVoucher * (share.feeFraction || 1));
            shareAmount += amount;
            const toVoucherTypeIds = (0, helpers_1.getToVoucherTypeIds)(billingModel, voucherWithDistribution, share);
            const [_newCollectionCommissionBillingVouchers, savedUpVoucher] = (0, helpers_1.handlePreventNegativeCreditorBalance)(billingModel, amount, shareBaseVoucher, toVoucherTypeIds, share);
            savedUpBillingVouchers = savedUpBillingVouchers.concat(savedUpVoucher ? savedUpVoucher : []);
            newCollectionCommissionBillingVouchers =
                newCollectionCommissionBillingVouchers.concat(_newCollectionCommissionBillingVouchers);
        }
        const newResidueBillingVoucher = (0, helpers_1.genResidueVouchers)(shareAmount, voucherWithDistribution, shareBaseVoucher, billingModel, _case);
        if (newResidueBillingVoucher) {
            newResidueBillingVouchers = newResidueBillingVouchers.concat(newResidueBillingVoucher);
        }
        newBillingVouchers = newBillingVouchers.concat(newCollectionCommissionBillingVouchers);
    }
    if (savedUpBillingVouchers.length) {
        const [_newResidueVouchers, _savedUpVouchers, _newVouchers] = (0, helpers_1.handleSavedUpVouchers)(newResidueBillingVouchers, savedUpBillingVouchers);
        newResidueBillingVouchers = _newResidueVouchers;
        savedUpBillingVouchers = _savedUpVouchers;
        newBillingVouchers = newBillingVouchers.concat(_newVouchers);
    }
    if (savedUpBillingVouchers.length &&
        caseVouchers &&
        vouchersWithDistribution[vouchersWithDistribution.length - 1] &&
        (0, helpers_1.isProbablyLastDepositOnAccount)(caseVouchers, documents, expirationSettings, vouchersWithDistribution[vouchersWithDistribution.length - 1]
            .contraCaseVoucher.date)) {
        newBillingVouchers = newBillingVouchers.concat(savedUpBillingVouchers.map((savedUpVoucher) => (Object.assign(Object.assign({}, savedUpVoucher), { depositCaseVoucherId: null, billingModelId: null, details: Object.assign(Object.assign({}, savedUpVoucher.details), { depositVoucherTypeId: null }) }))));
        savedUpBillingVouchers = [];
    }
    if (!vouchersWithInterest) {
        throw new Error('Billing: Could not find vouchers');
    }
    newOverheadBillingVouchers = (0, helpers_1.getOverheadVouchers)(baseVoucher, vouchersWithInterest, _case, billingModel);
    return [
        newBillingVouchers,
        newResidueBillingVouchers,
        newOverheadBillingVouchers,
    ];
};
exports.getShareVouchers = getShareVouchers;
//# sourceMappingURL=index.js.map